import cx from 'classnames';

import PlusIcon from 'src/assets/icons/Plus';
import { CustomButton } from 'src/components/CustomButton';

import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const CreateContentItem = ({ className }) => {
  const styles = useStyles();

  const { handleNewProjectClick } = useHandlers();

  return (
    <div className={cx(styles.root, className)}>
      <CustomButton
        className={styles.button}
        onClick={handleNewProjectClick}
        startIcon={<PlusIcon />}
        data-testid="createContentButton"
      >
        Create content
      </CustomButton>
    </div>
  );
};
